import { useQuery } from '@tanstack/react-query';
import api from '~/api';
import { useStoreId } from '~/providers/StoreUserProvider';

export function useStoreCustomer(customerEmail?: string) {
  const storeId = useStoreId();
  const queryKey = ['storeCustomer', storeId, `${customerEmail}`];
  return useQuery({
    queryKey,
    queryFn: () => {
      if (!customerEmail) throw new Error('Customer email is required');
      return api.store(storeId).customer.get({
        customerEmail,
      });
    },
    enabled: !!customerEmail,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
